import { Dispatch, SetStateAction, useEffect, useState } from 'react';
import { Typography } from '@mui/material';
import Dialog from '@mui/material/Dialog';
import { ActionButton } from '@ui/index';
import * as Styled from './styled';

export type CustomDialogProps = {
  opened: boolean;

  title?: string;
  text?: string | JSX.Element;
  positiveBtn?: {
    text: string;
    action: (props?: any) => void;
    color?:
      | 'primary'
      | 'inherit'
      | 'secondary'
      | 'success'
      | 'error'
      | 'info'
      | 'warning';
  };
  negativeBtn?: {
    text: string;
    action?: (props?: any) => void;
  };
};

export const CustomDialog = ({
  title,
  text,
  positiveBtn,
  negativeBtn,
  opened,
  setDialog,
}: CustomDialogProps & { setDialog: Dispatch<SetStateAction<CustomDialogProps>> }) => {
  const [open, setOpen] = useState(false);

  const onAction = () => {
    positiveBtn?.action();
    setDialog((prev) => ({ ...prev, opened: false }));
  };

  const onClose = () => {
    negativeBtn?.action?.();
    setDialog((prev) => ({ ...prev, opened: false }));
  };

  useEffect(() => {
    setOpen(opened);
  }, [opened]);

  if (!opened) return null;

  return (
    <Styled.Dialog onClose={onClose} open={open}>
      <Typography variant="h6">{title}</Typography>

      <Typography variant="body2">{text}</Typography>

      <Styled.Actions>
        <ActionButton kind="positive" onClick={onAction}>
          {positiveBtn?.text}
        </ActionButton>

        <ActionButton onClick={onClose}>{negativeBtn?.text}</ActionButton>
      </Styled.Actions>
    </Styled.Dialog>
  );
};
